import classes from './ReportResult.module.css';
import light from 'assets/roleplay/lightbulb.png';
import chat from 'assets/roleplay/chat.png';
import { Skeleton } from '@material-ui/lab';
const Improvements = ({ className = "", title =  "Practice & Improve", summary = {}, isLoadingResponse = false }) => {
  if (summary && summary?.areas_of_improvement?.length > 0)
    return (
      <div className={className}>
        <h4>⚠️ {title}</h4>
        {isLoadingResponse ? (
          <div className={classes.overallFeedback}>
            <Skeleton
              variant="rect"
              width="100%"
              height="10vh"
              style={{ borderRadius: '0.5rem' }}
            />
          </div>
        ) : (
          <div className={classes.containerPractice}>
            {summary?.areas_of_improvement?.map((item, index) => (
              <div key={`AreasOI-${index}`} className={classes.practice}>
                {typeof item === 'string' ? (
                  <div className={classes.item}>
                    <img src={light} alt="idea" />{' '}
                    <div className={classes.text}> AI Suggestion:</div>
                    <div className={classes.suggestion}>{item}</div>
                  </div>
                ) : (
                  <>
                    <div className={classes.item}>
                      <img src={chat} alt="said" />{' '}
                      <p>
                        You said:
                        <span className={classes.suggestion}>{` ${item?.what_rep_said}`}</span>
                      </p>
                    </div>
                    <div className={classes.item}>
                      <img src={light} alt="idea" />{' '}
                      <p>
                        Kai suggets:
                        <span className={classes.suggestion}>{` ${item?.suggested_phrase}`}</span>
                      </p>
                    </div>
                    <p className={classes.normalItem}>
                      Why this helps:
                      <span className={classes.helpText}>{` ${item?.why_phrase_works}`}</span>
                    </p>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  return null;
};

export default Improvements;
